/**
 * @author       julian@zumper.com (Julian Napolitan)
 * @copyright    Copyright (c) 2021, Zumper
 * @description  InfoOverlayContainer.js
 */

import { getVerticalsArray } from '@zcode/nr-utils'
import { routerConnect } from '@zcode/router-connect'
import type { RouteComponentProps } from '@zcode/router-utils'
import { selectIsCFR } from '../../../../../../modules/router/selectors/index'
import { InfoOverlay } from './InfoOverlay'

export const mapRouteToProps = (routeProps: RouteComponentProps) => {
  return {
    isCFR: selectIsCFR(routeProps),
    verticalsArray: getVerticalsArray(routeProps.location),
  }
}

export const InfoOverlayContainer = routerConnect(mapRouteToProps, { forwardRouteProps: true })(
  InfoOverlay
)
